// extracted by mini-css-extract-plugin
export var active = "_dm-2";
export var recordingDot = "_dm-1";
export var recordingIndicator = "_dm-0";